import { IconTrash } from '@tabler/icons-react';
import { Button, Group, Modal } from '@mantine/core';
import { styles } from '../../styles';
import { useProposal } from '../../context/ProposalContext';
import { useDisclosure } from '@mantine/hooks';
import { useTranslation } from 'react-i18next';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { deleteProposal } from '../../../../services/proposalsRoutes';

export default function DeleteProposal() {
  const [opened, { open, close }] = useDisclosure();
  // const {dispatchUserFeedback} = useProposal()
  const { t } = useTranslation();
  const { getAccessTokenSilently } = useAuth0();
  const navigate = useNavigate();
  const location = useLocation();
  const { proposalId } = location.state as { proposalId: string };

  // Handle Delete
  const handleDelete = async () => {
    try {
      const accessToken = await getAccessTokenSilently();
      await deleteProposal(accessToken, proposalId);
      const newPath = location.pathname.split('/').slice(0, -1).join('/');
      navigate(newPath);
    } catch (error) {
      console.error('Error deleting proposal:', error);
      alert('Failed to delete proposal.');
    }
  };

  return (
    <>
      <Button
        size="md"
        color="red"
        variant="light"
        leftSection={<IconTrash size={18} />}
        onClick={open}
      >
        {t('deleteProposal')}
      </Button>

      {/* Delete Confirmation Modal */}
      <Modal opened={opened} onClose={close} title={t('confirmDeletion')}>
        <div>{t('confirmDeleteProposal')}</div>
        <Group justify="flex-end">
          <Button color="gray" onClick={close}>
            {t('cancel')}
          </Button>
          <Button color="red" onClick={handleDelete}>
            {t('confirm')}
          </Button>
        </Group>
      </Modal>
    </>
  );
}
